// Languages
export const LANGUAGES = ['ru', 'ua', 'en', 'fr', 'es']